export const useCurrentPage = () => {
    const route = useRoute();
    return computed<number>(() => {
        return route.query?.page ? parseInt(route.query.page as string, 10) : 1;
    });
};
